import _ from 'lodash';
import { ofType } from 'redux-observable';
import { catchError, map, mergeMap, withLatestFrom } from 'rxjs/operators';
import { fetchAllFulfilled, FETCH_ALL } from '../../actions/entity';
import * as api from '../../../utils/api';
import * as fromState from '../../reducers';
import { ENTITY_CONFIG } from '../../../utils/constants';
import entityConfig from '../../../utils/entities';
import { takeUntilAppReset } from 'utils/helpers';

export default (action$, state$) => action$.pipe(
  ofType(FETCH_ALL),
  withLatestFrom(state$),
  mergeMap(([action, state]) =>
    api.getAll({
      controller: entityConfig[action.entityType][ENTITY_CONFIG.API_PATH],
      token: fromState.getUser(state).token
    }).pipe(
      takeUntilAppReset(action$),
      map(_.partial(fetchAllFulfilled, action.entityType)),
      catchError(api.onError)
    ))
);